export default "__VITE_ASSET__BkGHHZuI__"